export default __webpack_public_path__ + "c7bdaf895f711a4aade66dd109ae4008.png";